module.exports = __webpack_public_path__ + "static/media/bg_europe.5b58e768.jpg";